import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const errorContainer = style({
  paddingTop: 100,
});

export const errorBlock = style({
  ...typography['bodySm'],
  margin: `${space.s12}px 0`,
  padding: `${space.s16}px ${space.s12}px`,
  borderRadius: borderRadius.r8,
  textAlign: 'left',
  backgroundColor: themeVars.container.secondary.background.idle,
  whiteSpace: 'pre-wrap',
});
